import { render } from "./RegistrationSearchName.vue?vue&type=template&id=282b2139&scoped=true&ts=true"
import script from "./RegistrationSearchName.vue?vue&type=script&lang=ts"
export * from "./RegistrationSearchName.vue?vue&type=script&lang=ts"

import "./RegistrationSearchName.vue?vue&type=style&index=0&id=282b2139&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282b2139"]])

export default __exports__